const common_en = require('./common.json')
export default common_en